var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoUrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "9px",
    viewBox: "0 0 20 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-video-url") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Media-library-V2",
    transform: "translate(-437.000000, -4084.000000)",
    fill: "#8499C2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-video-url",
    transform: "translate(437.000000, 4084.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0434783,5.2173913 L6.08695652,5.2173913 C5.60695652,5.2173913 5.2173913,4.82782609 5.2173913,4.34782609 L5.2173913,4.34782609 C5.2173913,3.86782609 5.60695652,3.47826087 6.08695652,3.47826087 L13.0434783,3.47826087 C13.5234783,3.47826087 13.9130435,3.86782609 13.9130435,4.34782609 L13.9130435,4.34782609 C13.9130435,4.82782609 13.5234783,5.2173913 13.0434783,5.2173913 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5956522,0 L12.173913,0 C11.693913,0 11.3043478,0.389565217 11.3043478,0.869565217 L11.3043478,0.869565217 C11.3043478,1.34956522 11.693913,1.73913043 12.173913,1.73913043 L14.6347826,1.73913043 C16.0469565,1.73913043 17.313913,2.79652174 17.3869565,4.20782609 C17.466087,5.71217391 16.2695652,6.95652174 14.7826087,6.95652174 L12.173913,6.95652174 C11.693913,6.95652174 11.3043478,7.34608696 11.3043478,7.82608696 L11.3043478,7.82608696 C11.3043478,8.30608696 11.693913,8.69565217 12.173913,8.69565217 L14.7826087,8.69565217 C17.3243478,8.69565217 19.3573913,6.51391304 19.1104348,3.92086957 C18.8947826,1.66 16.8669565,0 14.5956522,0 Z M4.53478261,8.69565217 L6.95652174,8.69565217 C7.43652174,8.69565217 7.82608696,8.30608696 7.82608696,7.82608696 L7.82608696,7.82608696 C7.82608696,7.34608696 7.43652174,6.95652174 6.95652174,6.95652174 L4.49565217,6.95652174 C3.08347826,6.95652174 1.81652174,5.89913043 1.74347826,4.48782609 C1.66434783,2.98347826 2.86086957,1.73913043 4.34782609,1.73913043 L6.95652174,1.73913043 C7.43652174,1.73913043 7.82608696,1.34956522 7.82608696,0.869565217 L7.82608696,0.869565217 C7.82608696,0.389565217 7.43652174,0 6.95652174,0 L4.34782609,0 C1.80608696,0 -0.226956522,2.18173913 0.02,4.77478261 C0.235652174,7.03565217 2.26347826,8.69565217 4.53478261,8.69565217 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoUrl);
export default __webpack_public_path__ + "static/media/icon-video-url.b4eadee9460933f09ad7532de576e817.svg";
export { ForwardRef as ReactComponent };